var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import * as HERRAMIENTA from './constantes';
import BotonGrosorColor from './boton-grosor-color';
var BotonBorrador = (_temp = _class = function (_Component) {
  _inherits(BotonBorrador, _Component);

  function BotonBorrador() {
    _classCallCheck(this, BotonBorrador);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  BotonBorrador.prototype.render = function render() {
    var _props = this.props,
        seleccionado = _props.seleccionado,
        onPresionado = _props.onPresionado,
        grosores = _props.grosores,
        grosorSeleccionado = _props.grosorSeleccionado;
    return React.createElement(BotonGrosorColor, {
      herramientaId: HERRAMIENTA.BORRADOR_ID,
      seleccionado: seleccionado,
      onPresionado: onPresionado,
      herramientaGrosorId: HERRAMIENTA.BORRADOR_GROSOR_ID,
      grosores: grosores,
      grosorSeleccionado: grosorSeleccionado
    });
  };

  return BotonBorrador;
}(Component), _class.defaultProps = {
  grosores: HERRAMIENTA.GROSORES_BORRADOR_POR_DEFECTO
}, _temp);
BotonBorrador.propTypes = process.env.NODE_ENV !== "production" ? {
  /** lista de grosores */
  grosores: t.arrayOf(t.number),

  /** 
   * grosor inicialmente seleccionado, debe existir en la lista de grosores,
   * por defecto, el primero de la lista
   */
  grosorSeleccionado: t.number,
  seleccionado: t.bool,
  onPresionado: t.func
} : {};
export default BotonBorrador;